import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterAccueilPictoProps extends pictoProps {
}

export interface FooterAccueilPictoState extends pictoState {
}

export class FooterAccueilPicto extends Picto<FooterAccueilPictoProps,FooterAccueilPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerAccueilPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterAccueilPicto);
